import { ApiResponse } from "../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../Services/common/Axios.service";


const SERVICE_URL = ServiceEndPoint.account_service; 

export async function createSupplier(payload:any): Promise<ApiResponse<any>>{
  const response = await axiosService.post(`${SERVICE_URL}suppliers`, payload);
  return response.data;
}
export async function getSupplier(id:any): Promise<ApiResponse<any>>{
  const response = await axiosService.get(`${SERVICE_URL}suppliers/${id}`);
  return response.data;
}
export async function updateSupplier(id:any,payload:any): Promise<ApiResponse<any>>{
  const response = await axiosService.put(`${SERVICE_URL}suppliers/${id}`,payload);
  return response.data;
}
export async function deleteSupplier(id:number): Promise<ApiResponse<any>>{
  const response = await axiosService.delete(`${SERVICE_URL}suppliers/${id}`);
  return response.data;
}
